// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var DOM$SmartcutsMacros = require("../DOM.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var DOM__Node$SmartcutsMacros = require("../DOM__Node.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var TextContents$SmartcutsMacros = require("../TextContents.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../DOM__HtmlElement.bs.js");
var Selection__NonInputSelection$SmartcutsMacros = require("./Selection__NonInputSelection.bs.js");
var DomElementIdentifierGenerator$SmartcutsMacros = require("../DomElementIdentifierGenerator.bs.js");
var Selection__ContentEditableCursor$SmartcutsMacros = require("./Selection__ContentEditableCursor.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function t_encode(encoder_domElementRepresentation, v) {
  if (typeof v === "number") {
    return ["OutdatedSelection"];
  } else if (v.TAG === /* ContentEditableSelection */0) {
    return [
            "ContentEditableSelection",
            Curry._1(encoder_domElementRepresentation, v._0),
            Selection__NonInputSelection$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._1),
            TextContents$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._2)
          ];
  } else {
    return [
            "ContentEditableCursor",
            Curry._1(encoder_domElementRepresentation, v._0),
            Selection__ContentEditableCursor$SmartcutsMacros.Generic.t_encode(encoder_domElementRepresentation, v._1)
          ];
  }
}

function t_decode(decoder_domElementRepresentation, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContentEditableCursor" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Selection__ContentEditableCursor$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ContentEditableCursor */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ContentEditableSelection" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Selection__NonInputSelection$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 2));
          var match$5 = TextContents$SmartcutsMacros.Generic.t_decode(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 3));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              if (match$5.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* ContentEditableSelection */0,
                          _0: match$3._0,
                          _1: match$4._0,
                          _2: match$5._0
                        }
                      };
              }
              var e$2 = match$5._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "OutdatedSelection" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* OutdatedSelection */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(stringifyDomElementRepresentation, v) {
  if (typeof v === "number") {
    return "OutdatedSelection";
  }
  if (v.TAG === /* ContentEditableSelection */0) {
    var func = Selection__NonInputSelection$SmartcutsMacros.Generic.stringify;
    return "ContentEditableSelection(" + (Curry._1(stringifyDomElementRepresentation, v._0) + (", " + (Curry._2(func, stringifyDomElementRepresentation, v._1) + ", textContents)")));
  }
  var func$1 = Selection__ContentEditableCursor$SmartcutsMacros.Generic.stringify;
  return "ContentEditableCursor(" + (Curry._1(stringifyDomElementRepresentation, v._0) + (Curry._2(func$1, stringifyDomElementRepresentation, v._1) + ")"));
}

var Generic = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}

function t_decode$1(v) {
  return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}

function stringify$1(param) {
  return stringify(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify, param);
}

function fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot) {
  if (!selectionSnapshot) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected selectionSnapshot to have a range when ContentEditableSelectionOrCursor.ForRecordingAndAuthoring.fromSelectionSnapshot()");
  }
  var match = selectionSnapshot._0;
  var rootNode = match.rootNode;
  if (DOM__Node$SmartcutsMacros.isNodeOrItsAncestorDetached(rootNode)) {
    return /* OutdatedSelection */0;
  }
  var contentEditableHost = DOM$SmartcutsMacros.ContentEditable.findHost(DOM__HtmlElement$SmartcutsMacros.ofNodeOrItsAncestor(rootNode));
  if (match.collapsed) {
    var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(contentEditableHost, domElementIdentifierGenerator);
    var maybeCursor = Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot);
    var cursor = OptionUtils$SmartcutsMacros.getExn("Expected to get cursor", maybeCursor);
    return {
            TAG: /* ContentEditableCursor */1,
            _0: {
              domElementIdentifier: domElementIdentifier,
              selector: Selector$SmartcutsMacros.forDomElement(contentEditableHost)
            },
            _1: cursor
          };
  }
  var domElementIdentifier$1 = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(contentEditableHost, domElementIdentifierGenerator);
  var selection = Selection__NonInputSelection$SmartcutsMacros.ForRecording.fromSelectionSnapshot(domElementIdentifierGenerator, selectionSnapshot);
  var textContents = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.fromElement(domElementIdentifierGenerator, contentEditableHost);
  return {
          TAG: /* ContentEditableSelection */0,
          _0: {
            domElementIdentifier: domElementIdentifier$1,
            selector: Selector$SmartcutsMacros.forDomElement(contentEditableHost)
          },
          _1: selection,
          _2: textContents
        };
}

function extractSelectorToContentEditableHost(selectionOrCursor) {
  if (typeof selectionOrCursor === "number") {
    return ;
  } else {
    return selectionOrCursor._0.selector;
  }
}

function updateSelector(f, selectionOrCursor) {
  if (typeof selectionOrCursor === "number") {
    return /* OutdatedSelection */0;
  }
  if (selectionOrCursor.TAG === /* ContentEditableSelection */0) {
    var contentEditableHost = selectionOrCursor._0;
    return {
            TAG: /* ContentEditableSelection */0,
            _0: {
              domElementIdentifier: contentEditableHost.domElementIdentifier,
              selector: Curry._1(f, contentEditableHost.selector)
            },
            _1: Selection__NonInputSelection$SmartcutsMacros.ForRecording.updateSelector(f, selectionOrCursor._1),
            _2: TextContents$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, selectionOrCursor._2)
          };
  }
  var contentEditableHost$1 = selectionOrCursor._0;
  return {
          TAG: /* ContentEditableCursor */1,
          _0: {
            domElementIdentifier: contentEditableHost$1.domElementIdentifier,
            selector: Curry._1(f, contentEditableHost$1.selector)
          },
          _1: Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.updateSelector(f, selectionOrCursor._1)
        };
}

var ForRecordingAndAuthoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1,
  fromSelectionSnapshot: fromSelectionSnapshot,
  extractSelectorToContentEditableHost: extractSelectorToContentEditableHost,
  updateSelector: updateSelector
};

var SelectionSnapshot;

var NonInputSelection;

var ContentEditableCursor;

exports.SelectionSnapshot = SelectionSnapshot;
exports.NonInputSelection = NonInputSelection;
exports.ContentEditableCursor = ContentEditableCursor;
exports.Generic = Generic;
exports.ForRecordingAndAuthoring = ForRecordingAndAuthoring;
/* DOM-SmartcutsMacros Not a pure module */
